import type { CityConfig } from "../city-template/types";

export const scarboroughConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Cumberland County Clerk", href: "https://www.cumberlandcounty.org/", description: "Cumberland County Clerk — marriage license issuance" },
    { label: "Divorce Records — Cumberland County Clerk", href: "https://www.cumberlandcounty.org/", description: "Cumberland County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Scarborough",
  state: "Maine",
  stateAbbr: "ME",
  slug: "scarborough",
  route: "/scarborough",
  title: "Emergency Passport Scarborough, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Scarborough, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Scarborough, South Portland, Cape Elizabeth, Gorham, and Cumberland County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Scarborough, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Scarborough and the Greater Portland area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scarborough%20Maine%20coastal%20landscape%2C%20beautiful%20sandy%20beach%20with%20rocky%20coastline%20at%20Higgins%20Beach%2C%20scenic%20New%20England%20coastal%20view%20with%20marshland%20and%20pine%20trees%2C%20golden%20hour%20light%20on%20the%20Atlantic%20Ocean%2C%20professional%20photography%2C%20no%20people%20or%20visible%20text%2C%20peaceful%20coastal%20town%20atmosphere%20with%20Maines%20natural%20shoreline%20beauty%2C%20dramatic%20clouds%20and%20scenic%20seascape&width=1800&height=700&seq=scarborough-me-hero-001&orientation=landscape",
  heroImageAlt: "Scarborough Maine beautiful coastal beach at Higgins Beach on the Atlantic Ocean",
  geoPosition: "43.5781;-70.3630",
  geoPlacename: "Scarborough, Maine",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 110 miles (2 hours) from Scarborough, ME",
  },
  nearbyCitiesZips: [
    { name: "Downtown Scarborough", zips: "04074" },
    { name: "South Portland", zips: "04106" },
    { name: "Cape Elizabeth", zips: "04107" },
    { name: "Gorham", zips: "04038" },
    { name: "Westbrook", zips: "04092" },
    { name: "Saco", zips: "04072" },
    { name: "Biddeford", zips: "04005" },
    { name: "Old Orchard Beach", zips: "04064" },
    { name: "Falmouth", zips: "04105" },
    { name: "Portland", zips: "04101" },
    { name: "Pine Point", zips: "04074" },
    { name: "Higgins Beach", zips: "04074" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Scarborough departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in South Portland", route: "/south-portland" },
    { name: "Emergency passport help in Portland", route: "/portland-me" },
    { name: "Urgent passport services in Gorham", route: "/gorham" },
    { name: "Same-day passport help in Westbrook", route: "/westbrook" },
    { name: "Expedited passport services in Saco", route: "/saco" },
    { name: "Passport courier services in Cape Elizabeth", route: "/cape-elizabeth" },
    { name: "Rush passport help in Biddeford", route: "/biddeford" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Scarborough, Maine remotely via secure courier. We do not have a walk-in office in Scarborough — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Scarborough travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving Greater Portland and the southern Maine coast",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Scarborough and the Greater Portland area. From the coastal beaches at Higgins Beach and Pine Point to the suburban neighborhoods near the Maine Mall — we help Scarborough travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Scarborough neighborhoods and nearby towns including South Portland, Cape Elizabeth, Gorham, Westbrook, Saco, Biddeford, Old Orchard Beach, and Falmouth. If you are in the Greater Portland area or southern Maine coast, we have you covered.",
  howItWorksIntro: "Most Scarborough travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Scarborough is a popular coastal suburb of Portland with frequent travelers. Whether you're heading to Europe, the Caribbean, or Canada, here are the most common mistakes we see from Scarborough-area travelers.",
  testimonialsIntro: "Scarborough travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Scarborough? Here are the most common ones we hear from the Greater Portland area.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Scarborough international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Katherine D.",
      location: "Scarborough, ME",
      rating: 5,
      text: "Booking a trip to Greece for our anniversary and discovered my passport was expired. Fast Passport Center had my renewal done in 3 days. I shipped from the Scarborough UPS Store and everything was perfect.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas M.",
      location: "Cape Elizabeth, ME",
      rating: 5,
      text: "Lost my passport five days before a business trip to Singapore. Fast Passport Center handled the DS-64 form and got me a replacement in 48 hours. Incredible speed for the Portland area.",
      service: "Lost Passport",
    },
    {
      name: "Linda S.",
      location: "Scarborough, ME",
      rating: 5,
      text: "Emergency passport for a family emergency in Ireland. Fast Passport Center was the only service that could actually deliver in 24 hours. Compassionate and professional throughout the entire process.",
      service: "Emergency Passport",
    },
    {
      name: "Paul R.",
      location: "Gorham, ME",
      rating: 5,
      text: "Child passport for our two kids heading to Mexico. Fast Passport Center helped us navigate both parents needing to be present and had their passports in 5 days. Perfect service.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "scarborough-1",
      name: "Scarborough Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "70 Black Point Rd",
      city: "Scarborough",
      state: "ME",
      zip: "04074",
      phone: "(207) 883-4341",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Scarborough",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Scarborough and Cape Elizabeth residents. Appointments required. Call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "scarborough-2",
      name: "South Portland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "425 Broadway",
      city: "South Portland",
      state: "ME",
      zip: "04106",
      phone: "(207) 767-3954",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "4 miles from Scarborough",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Greater Portland residents. More appointment slots available.",
      icon: "ri-mail-line",
    },
    {
      id: "scarborough-3",
      name: "Portland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 Forest Ave",
      city: "Portland",
      state: "ME",
      zip: "04101",
      phone: "(207) 871-8091",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "7 miles from Scarborough",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility in the region with the most appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "scarborough-4",
      name: "Gorham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Post Office Rd",
      city: "Gorham",
      state: "ME",
      zip: "04038",
      phone: "(207) 839-4701",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from Scarborough",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good option for Gorham and Buxton residents. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "scarborough-5",
      name: "Saco Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "28 Main St",
      city: "Saco",
      state: "ME",
      zip: "04072",
      phone: "(207) 283-3171",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles from Scarborough",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good for Biddeford and Old Orchard Beach residents.",
      icon: "ri-mail-line",
    },
    {
      id: "scarborough-6",
      name: "Westbrook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1041 Main St",
      city: "Westbrook",
      state: "ME",
      zip: "04092",
      phone: "(207) 854-2501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6 miles from Scarborough",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for Westbrook and Windham residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Maine photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Scarborough acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Scarborough applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Scarborough families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Scarborough travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Scarborough or Portland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Scarborough address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Scarborough, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Scarborough in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Scarborough travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Scarborough, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Scarborough residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Scarborough, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Scarborough with no office visit required. We serve all Scarborough neighborhoods and the Greater Portland area. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How close is Scarborough to the Boston Passport Agency?",
      a: "Scarborough is approximately 110 miles from the Boston Passport Agency — about a 2-hour drive. With Fast Passport Center, you avoid that trip entirely. We courier your documents directly to State Department facilities.",
    },
    {
      q: "What acceptance facilities are near Scarborough, Maine?",
      a: "Options near Scarborough include the Scarborough Post Office (04074), South Portland Post Office (04106), and Portland Main Post Office (04101). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "What if I live in South Portland, Cape Elizabeth, or Gorham?",
      a: "We serve all of Greater Portland and southern Cumberland County including Scarborough, South Portland, Cape Elizabeth, Gorham, Westbrook, Falmouth, and Portland. Our overnight shipping labels work from any UPS location, so your exact address doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Scarborough?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline and needs.",
    },
    {
      q: "What documents do I need for a first-time passport in Scarborough?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Scarborough?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Scarborough families through the entire process and help schedule acceptance clerk appointments.",
    },
    {
      q: "Is there a UPS Store near Scarborough for shipping documents?",
      a: "Yes. There are multiple UPS Store locations in Scarborough, South Portland, and Portland. We provide a prepaid overnight label — just drop your package at any UPS location or schedule a pickup. The Scarborough Post Office also handles USPS Priority Mail Express.",
    },
    {
      q: "Can I get passport photos taken in Scarborough?",
      a: "Yes. CVS Pharmacy, Rite Aid, and Walgreens in Scarborough and South Portland all offer passport photo services. The Walmart in Scarborough also has a photo center. We recommend reviewing your photos with us before your acceptance clerk visit.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Scarborough", address: "400 US Route 1, Scarborough, ME 04074", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Rite Aid — Scarborough", address: "300 US Route 1, Scarborough, ME 04074", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Scarborough", address: "200 US Route 1, Scarborough, ME 04074", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walmart Photo Center — Scarborough", address: "500 Gallery Blvd, Scarborough, ME 04074", hours: "Mon–Sun: 7AM–11PM" },
    { name: "UPS Store — Scarborough", address: "400 US Route 1, Scarborough, ME 04074", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — South Portland", address: "100 Westbrook St, South Portland, ME 04106", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — South Portland", address: "200 Westbrook St, South Portland, ME 04106", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Portland", address: "150 Forest Ave, Portland, ME 04101", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "BMV — Scarborough",
      address: "415 US Route 1, Scarborough, ME 04074",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. Online appointment booking available.",
      featured: true,
    },
    {
      name: "BMV — South Portland",
      address: "200 Westbrook St, South Portland, ME 04106",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center. Online appointment system available.",
      featured: true,
    },
    {
      name: "BMV — Portland",
      address: "125 Forest Ave, Portland, ME 04101",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Main Portland location with full services.",
      featured: false,
    },
    {
      name: "BMV — Gorham",
      address: "1 Post Office Rd, Gorham, ME 04038",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Basic services. Book appointment online.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "6 miles from Scarborough (12 minutes)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with direct flights to Canada, Florida, and major U.S. hubs. The closest international departure point for Scarborough and the Greater Portland area.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: true,
    },
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "125 miles from Scarborough (2 hours)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport. Alternative for northern connections and seasonal international flights.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "110 miles from Scarborough (2 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many southern Maine travelers connect through Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};